"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var notices_1 = require("./notices/notices");
jQuery(document).ready(function () {
    var notices = new notices_1.EpsilonNotices();
    notices.init();
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/admin/admin.ts
// module id = 33
// module chunks = 2